
import {ApolloError} from '@apollo/client/core';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { flatMap as _flatMap } from 'lodash-es';
import { finalize, map } from 'rxjs/operators';


import { ToastrService } from 'core/toastr.service';

import { CampaignWithoutTagsFragment, CreateCampaignGQL } from 'generated/graphql';

@Component({
  selector: 'app-campaign-create',
  templateUrl: './campaign-create.component.html',
})

export class CampaignCreateComponent {
  @Output() saved = new EventEmitter<CampaignWithoutTagsFragment>();
  isSubmitting = false;
  // errorMessage is set when there is an error.
  errorMessages: Array<string>;
  // Value that is sent as the variables in the GQL mutation.
  input = {
    name: '',
    participants: []
  };

  constructor(
    private _createCampaignGQL: CreateCampaignGQL,
    private toastrService: ToastrService,
    private cd: ChangeDetectorRef) {
  }

  // Called when 'create campaign' button is clicked.
  createCampaign() {
    this.isSubmitting = true;
    // Reset error message;
    this.errorMessages = [];

    // Send mutation to server
    this._createCampaignGQL.mutate(
      { input: this.input },
    ).pipe(
      map(({ data }) => data.createCampaign.campaign),
      finalize(() => this.isSubmitting = false))
      .subscribe(
        // Handle success
        (campaign) => {
          this.toastrService.success('Campaign Created!');
          this.saved.emit(campaign);
          this.cd.markForCheck();
        },
        // Handle errors
        (err: ApolloError) => {
          console.error(err.graphQLErrors);
          // Flatten errors into single error message
          // and display to user
          this.errorMessages = _flatMap(err.graphQLErrors, e => e.message);
          this.cd.markForCheck();
        }
      );
  }
}
